module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_happyhour-6604034f9b0707a802ca84edbecbbd18.jpg";